<template>
  <div id="app" class="w-full overflow-hidden">
    <Loading :active="isLoading"></Loading>
    <router-view></router-view>
  </div>
</template>
<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  components: {
    Loading
  },
  setup () {
    const store = useStore()
    const isLoading = computed(() => store.getters['isLoading'])

    return {
      isLoading
    }
  }
}
</script>
<style lang="scss">
#app {
  // font-family: 'cubic-11';
  background: #EEE7E0;
}
</style>
